import React, { useState } from 'react';
import styles from './../../../../styles/sass/components/ProductTourModal.module.scss';
import SwipeableViews from 'react-swipeable-views';
import { ArrowRight, ArrowLeft } from 'phosphor-react';
import { Button } from '@material-ui/core';
import PaginationDots from './PaginationDots';
import { isMobile, isTablet } from '../../../../lib/getDeviceSize';
import { X } from 'phosphor-react';

interface Props {
  handleClose: Function;
}

const ProductTourModalContent: React.FC<Props> = ({ handleClose }) => {
  const TOTAL_PAGES = 5;

  const [currentPage, updatePage] = useState(0);

  const handleClick = () => {
    if (currentPage == TOTAL_PAGES - 1) {
      handleClose();
    } else {
      updatePage(currentPage + 1);
    }
  };

  const handleBack = () => {
    updatePage(currentPage - 1);
  };

  const goToPage = (index: number) => updatePage(index);

  const renderButton = (text: string, style?: object) => {
    return (
      <Button
        className={styles.continueButton}
        onClick={handleClick}
        style={style}
      >
        {text} <ArrowRight size={22} style={{ marginLeft: 5 }} />
      </Button>
    );
  };

  const renderBackButton = (style?: object) => {
    if (currentPage !== 0) {
      return (
        <Button
          className={styles.backButton}
          onClick={handleBack}
          style={style}
        >
          <ArrowLeft size={32} color="#463264" weight="regular" />
        </Button>
      );
    }
  };

  const renderCloseButton = () => {
    return (
      <Button className={styles.closeButton} onClick={() => handleClose()}>
        <X size={32} />
      </Button>
    );
  };

  const pages = [
    {
      component: (
        <React.Fragment>
          <div className={styles.pageContainer}>
            <div className={styles.img} style={{ margin: '10px 0px 10px 0px' }}>
              <img src="/static/img/dashboard/product_tour/house-blob.svg" />
            </div>
            <div
              className={styles.heading}
              style={{ fontSize: 22 }}
            >{`Welcome to your Torii dashboard! `}</div>
            <div className={styles.subText}>
              Let’s get started by taking a look at everything{' '}
              <br className="no-mobile" /> your dashboard will do.
            </div>
            {isMobile() || isTablet()
              ? renderButton(`Let's go`)
              : renderButton('Okay, let’s go')}
          </div>
        </React.Fragment>
      ),
    },

    {
      component: (
        <React.Fragment>
          <div className={styles.pageContainer}>
            <div
              className={styles.heading}
              style={{ padding: 0 }}
            >{`Your home for all things home! `}</div>
            <div className={styles.img}>
              <img src="/static/img/dashboard/product_tour/dashboard-wireframe.svg" />
            </div>
            <div className={styles.subText}>
              We know buying a home can sometimes feel{' '}
              <br className="no-mobile" />
              overwhelming, so we built a dashboard to help you{' '}
              {!isMobile() && <br />} manage the entire process.
            </div>
            {renderButton('Go on...', { margin: '20px 0px 10px 0px' })}
          </div>
        </React.Fragment>
      ),
    },

    {
      component: (
        <React.Fragment>
          <div className={styles.pageContainer}>
            <div
              className={styles.heading}
              style={{ fontSize: 23 }}
            >{`Home search that really gets you`}</div>
            <div className={styles.img} style={{ margin: 0 }}>
              <img src="/static/img/dashboard/product_tour/search-wireframe.svg" />
            </div>
            <div className={styles.subText}>
              Personalized listing recommendations based on what matters to you
              most, superpowered by AI.
            </div>
            {renderButton('Tell me about To-Do lists', {
              margin: isMobile() ? '10px 0px 6px 0px' : '15px 0px 20px 0px',
            })}
          </div>
        </React.Fragment>
      ),
    },

    {
      component: (
        <React.Fragment>
          <div className={styles.pageContainer}>
            <div className={styles.heading}>{`Always know what's next`}</div>
            <div className={styles.img}>
              <img src="/static/img/dashboard/product_tour/todo-wireframe.svg" />
            </div>
            <div className={styles.subText}>
              Simple to-do lists to help you stay on track through{' '}
              <br className="no-mobile" /> every step of your home purchase.
            </div>
            {renderButton('I like it, what else?', {
              margin: isMobile() ? '20px 0px 10px 0px' : '10px 0px 10px 0px',
            })}
          </div>
        </React.Fragment>
      ),
    },

    {
      component: (
        <React.Fragment>
          <div className={styles.pageContainer}>
            <div className={styles.heading}>{`Your homebuying dream team`}</div>
            <div className={styles.img} style={{ margin: 0 }}>
              <img src="/static/img/dashboard/product_tour/toriiteam-wireframe.svg" />
            </div>
            <div className={styles.subText}>
              Chat anytime with your Torii real estate agent{' '}
              <br className="no-mobile" /> or our expert customer support.
            </div>
            {renderButton('Good to know. Let me loose!', {
              margin: isMobile() ? '10px 0px 15px 0px' : '',
            })}
          </div>
        </React.Fragment>
      ),
    },
  ];

  return (
    <div>
      <div className={styles.closeButtonContainer}>
        {renderBackButton()}
        {renderCloseButton()}
      </div>
      <SwipeableViews disabled index={currentPage}>
        {pages.map((page: any, index: number) => {
          return (
            <div key={index} className={styles.productTourModal}>
              {page.component}
              <PaginationDots
                totalIndices={TOTAL_PAGES}
                currentIndex={index}
                goToPage={goToPage}
                key={index}
              />
            </div>
          );
        })}
      </SwipeableViews>
    </div>
  );
};

export default ProductTourModalContent;
